import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { WorkPermit } from 'src/app/shared/interfaces/interfaces';

@Component({
  standalone: false,
  selector: 'app-list-of-cla-requests',
  templateUrl: './list-of-cla-requests.component.html',
  styleUrls: ['./list-of-cla-requests.component.scss'],
})
export class ListOfClaRequestsComponent implements OnInit {
  workPermits: WorkPermit[] = [];
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  page = 1;
  totalPages = 1;

  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private router: Router
  ) {
    this.workPermits = [
      {
        refNo: 30356894,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 32545698,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 24589657,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 84785236,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 30356894,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 32545698,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 24589657,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
      {
        refNo: 84785236,
        startDate: '2nd May, 2023',
        endDate: '10th May, 2023',
        approvalStatus: 'Approved',
      },
    ];
  }

  ngOnInit(): void {}

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  goToDetails(id: number) {
    this.router.navigate(['/work-entry-permit-details', id]);
  }
}
